import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { IUserInfoEditResponse, IUserInfoViewResponse,IStoreUserTeleworkDataInDB } from 'src/models/api-response/user-info-response.interface';
import { TokenStorageService } from './token-storage.service';
import { IUserListModel, IUserProfileImage, IUserSearchResponse } from 'src/models/api-response/user-search-response.interface';
import { IDevice, ILiteUser, IUser, IUserInfo, IUserPhoto, TeleworkReport } from 'src/models/user/user-info.interface';
import { IActiveDirectoryUserListResponse } from 'src/models/api-response/add-user-response.interface';
import { INewUser } from 'src/models/user/new-user.interface';
import { IUserPhotoResponse } from 'src/models/api-response/user-photo-response.interface';
import { IDMSUserPhotoResponse } from 'src/models/api-response/user-idms-photo-response.interface';
import { AuthService } from './auth.service';
import { IGroup } from 'src/models/user/group.interface';
import { IAllUsersResponse, SuggestUser } from 'src/models/api-response/all-users-response.interface';
import { BehaviorSubject, concatMap, map, take, tap } from 'rxjs';
import { UserRoles } from 'src/models/user/rolescope-interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private token: string = "";
  private userName: string = "";
  loggedInObservable: Observable<boolean>;

  private imagesData$: Observable<IUserProfileImage>;
  private searchResults$: BehaviorSubject<IUserListModel[]> = new BehaviorSubject<IUserListModel[]>([]);

  constructor(private http: HttpClient, private tokenStorageService: TokenStorageService, private authService: AuthService) {
    this.loggedInObservable = this.authService.isLoggedIn();

    this.loggedInObservable.subscribe(b => {
      if (b) {
        this.token = this.tokenStorageService.getToken();
        this.userName = this.tokenStorageService.getUserName();
      }
    });

    this.imagesData$ = new Observable(observer => {

    });
  }

  public assureToken(): Observable<boolean> {
    return new Observable<boolean>((s) => {
      this.loggedInObservable.subscribe(b => {
        if (b && this.token) {
          s.next(b);
        }
        else {
          setTimeout(() => {
            if (b && this.token) {
              s.next(b);
            }
          }, 1000);
        }
      });
    });
  }

  public search(name: string, divisionID: string, sectionID: string, PhoneNumber: string, PageNumber: number, PageLength: number): Observable<IUserSearchResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams();
    params = params.append('namesearch', name);
    params = params.append('divisionID', divisionID);
    params = params.append('sectionID', sectionID);
    //params = params.append('PhoneNumber', PhoneNumber);
    params = params.append('PageNumber', PageNumber);
    params = params.append('PageLength', PageLength);
    return this.http.get<IUserSearchResponse>(environment.apiUrl + '/GetUsers2',
      { 'headers': authHeader, 'params': params });
  }

  public search2(name: string, divisionID: string, sectionID: string, PageNumber: number, PageLength: number): Observable<IUserListModel[]> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams();
    params = params.append('namesearch', name);
    params = params.append('divisionID', divisionID);
    params = params.append('sectionID', sectionID);
    //params = params.append('PhoneNumber', PhoneNumber);
    params = params.append('PageNumber', PageNumber);
    params = params.append('PageLength', PageLength);
    return this.http.get<IUserSearchResponse>(environment.apiUrl + '/GetUsers2',
      { 'headers': authHeader, 'params': params }).pipe(
        tap((data: IUserSearchResponse) => {
          const currentResults = this.searchResults$.getValue();
          this.searchResults$.next([...currentResults, ...data.userListModel]);
        }),
        concatMap((data: IUserSearchResponse) => {
          if (data.paginationInfodetails && data.paginationInfodetails.nextPage) {
            return this.search2(name, divisionID, sectionID, PageNumber + 1, PageLength);
          } else {
            return this.searchResults$;
          }
        })
      );
  }

  public suggest(searchFor: string): Observable<SuggestUser[]> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams();
    params = params.append('searchFor', searchFor);

   return this.http.get<IAllUsersResponse>(environment.apiUrl + '/GetSuggestUsers',
      { 'headers': authHeader, 'params': params }).pipe(
        tap(_ => this.log(`searched for: ${searchFor}`)),
        map(searchResponse => {
          return searchResponse.usersList;
        })
      );
  }

  public GetUserLightData(searchFor: string): Observable<SuggestUser[]> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams();
    params = params.append('searchFor', searchFor);

   return this.http.get<IAllUsersResponse>(environment.apiUrl + '/GetUserLightData',
      { 'headers': authHeader, 'params': params }).pipe(
        tap(_ => this.log(`searched for: ${searchFor}`)),
        map(searchResponse => {
          return searchResponse.usersList;
        })
      );
  }

  //locading division employee

  //for direct reportee list
  public GetDirectReporteeList(supid:number): Observable<IUserSearchResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
    let idList: number[] = [];
    
    let params = new HttpParams();
    params = params.append('supid',supid);

    return this.http.get<IUserSearchResponse>(environment.apiUrl + '/GetDirectReporteeList', { 'headers': authHeader, 'params': params });
  }

  //for direct reportee list
  public GetTeleworkScheduleReportSection(userinfoid:number, divid:number): Observable<TeleworkReport[]> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let idList: number[] = [];
    
    let params = new HttpParams();
    params = params.append('userid',userinfoid).append('divid',divid);
    return this.http.get<TeleworkReport[]>(environment.apiUrl + '/GetTeleworkScheduleReport', { 'headers': authHeader, 'params': params });
  }

  //for search employee for direct reportee
  public SearchEmployeeForDirectReportee(userid:number, divid:number, sectionid:number, userkeyword: string): Observable<IUserSearchResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
    let idList: number[] = [];
    
    let params = new HttpParams();
    params = params.append('userid',userid).append('divid',divid).append('sectionid',sectionid).append('userkeyword',userkeyword);
    return this.http.get<IUserSearchResponse>(environment.apiUrl + '/SearchEmployeeForDirectReportee', { 'headers': authHeader, 'params': params });
  }




  //for user search history
  public historysearch(): Observable<IUserSearchResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
    let idList: number[] = [];
    let viewedUsers: IGroup[] = this.tokenStorageService.getViewedUsers() ?? [];
    viewedUsers.forEach(f => {
      idList.push(f.ID);
    })
    let params = new HttpParams();
    params = params.append('userinfoid', LoggedInUserId);
    params = params.append('viewedUsers', idList.join());
    // console.log('params:', params);
    return this.http.get<IUserSearchResponse>(environment.apiUrl + '/GetSearchProfileList2', { 'headers': authHeader, 'params': params });
  }

  // for all users page
  public allUsers(page: number): Observable<IAllUsersResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
    let params = new HttpParams();
    params = params.append('userinfoid', LoggedInUserId);
    return this.http.get<IAllUsersResponse>(environment.apiUrl + '/GetAllUsers', { 'headers': authHeader, 'params': params });
  }

  //Method use to retrieve user info for viewing - section, companies and division returns a string
  public getUserDetails(userId: number): Observable<IUserInfoViewResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let LoggedInUserId = Number(this.tokenStorageService.getUserInfoId());
    let params = new HttpParams().append('userinfoid', userId);
    params = params.append('LoggedInUserInfoId', LoggedInUserId);
    //console.log("tracking loggedinuserid");
    return this.http.get<IUserInfoViewResponse>(environment.apiUrl + '/GetUserDetails', { 'headers': authHeader, 'params': params });
  }

  //Method use to retrieve user info for edit - section, companies and division returns a number
  public getUserInfoById(userId: number): Observable<IUserInfoEditResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams().append('userinfoid', userId);
    return this.http.get<IUserInfoEditResponse>(environment.apiUrl + '/GetUserProfile', { 'headers': authHeader, 'params': params });
  }

  public getPhoto(userId: number, thumbnailSize: number): Observable<Blob> {
    const headers = new HttpHeaders({
      'Authorization': this.token,
      'UserName': this.userName,
      'responseType': 'image/jpeg',
      'Accept': 'image/jpeg',
      'AuthenticationToken': environment.AuthenticationToken,
    });
    let params = new HttpParams().append('userinfoid', userId).append('thumbnailSize', thumbnailSize);
    return this.http.get(environment.apiUrl + '/GetUserPhoto',
      { 'headers': headers, 'params': params, 'responseType': 'blob' });
  }

  public getPhotosList(userIds: number[], thumbnailSize: number, pageLength: number): Observable<IUserProfileImage[]> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams({ fromObject: { 'userIDs': userIds } });
    params = params.append('thumbnailSize', thumbnailSize);
    params = params.append('PageLength', pageLength);

    //console.log(`getting profile thumbnails for: ${userIds}`);

    return this.http.get<IUserProfileImage[]>(environment.apiUrl + '/GetUserPhotos', { 'headers': authHeader, 'params': params });
  }

  public getUserInfoByLoginName(loginName: string): Observable<IUserInfoEditResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let params = new HttpParams().append('loginName', loginName);
    return this.http.get<IUserInfoEditResponse>(environment.apiUrl + '/GetUserInfoByLoginName', { 'headers': authHeader, 'params': params });
  }

  //Method use to update user devices, command options: U - update, I - insert, D - delete
  public updatePhoneDeviceList(device: IDevice, userId: number, command: string): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let body = {
      "UserInfoID": userId,
      "UserDeviceID": device.id,
      "DeviceTypeID": device.typeID,
      "DeviceNumber": device.number,
      "IsVisible": device.visible,
      "IsPreference": device.preferred,
      "IUCommand": command
    };
    return this.http.post(environment.apiUrl + '/UpdateUserDevice', body, { 'headers': authHeader, responseType: "text" });
  }


  //Method use to update user info - except phone devices and direct reports
  public updateUserGeneralInfo(info: IUserInfo): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    const body = {
      "ID": info.id,
      "FirstName": info.firstName,
      "LastName": info.lastName,
      "EmailAddress": info.email,
      "DivisionID": info.divisionID,
      "SectionID": info.sectionID,
      "JobTitle": info.jobTitle,
      "CompanyID": info.companyID,
      "CallSign": info.callSign,
      "IsActive": info.isActive,
      "Hours": info.workTime.hours,
      "Mon": info.workTime.mon,
      "Tue": info.workTime.tue,
      "Wed": info.workTime.wed,
      "Thu": info.workTime.thu,
      "Fri": info.workTime.fri,
      "Sat": info.workTime.sat,
      "Sun": info.workTime.sun,
      "startTime":  info.teleWorkData.startTime, 
      "startAMPM": info.teleWorkData.startAMPM,
      "endTime":  info.teleWorkData.endTime, 
      "endAMPM": info.teleWorkData.endAMPM,
      "poMonday":  info.teleWorkData.poMonday,
      "poTuesday":  info.teleWorkData.poTuesday,
      "poWednesday":  info.teleWorkData.poWednesday, 
      "poThursday": info.teleWorkData.poThursday,
      "poFriday": info.teleWorkData.poFriday,
      "poSaturday": info.teleWorkData.poSaturday,
      "poSunday":info.teleWorkData.poSunday,
      "ptMonday": info.teleWorkData.ptMonday,
      "ptTuesday": info.teleWorkData.ptTuesday,
      "ptWednesday": info.teleWorkData.ptWednesday,
      "ptThursday": info.teleWorkData.ptThursday,
      "ptFriday": info.teleWorkData.ptFriday,
      "ptSaturday": info.teleWorkData.ptSaturday,
      "ptSunday": info.teleWorkData.ptSunday,
      "npoMonday":  info.teleWorkData.npoMonday,
      "npoTuesday":  info.teleWorkData.npoTuesday,
      "npoWednesday":  info.teleWorkData.npoWednesday, 
      "npoThursday": info.teleWorkData.npoThursday,
      "npoFriday": info.teleWorkData.npoFriday,
      "npoSaturday": info.teleWorkData.npoSaturday,
      "npoSunday":info.teleWorkData.npoSunday,
      "nptMonday": info.teleWorkData.nptMonday,
      "nptTuesday": info.teleWorkData.nptTuesday,
      "nptWednesday": info.teleWorkData.nptWednesday,
      "nptThursday": info.teleWorkData.nptThursday,
      "nptFriday": info.teleWorkData.nptFriday,
      "nptSaturday": info.teleWorkData.nptSaturday,
      "nptSunday": info.teleWorkData.nptSunday,
      "isAdmin": info.isAdmin,
      "isSupervisor": info.isSupervisor,
      "isDeveloper": info.isDeveloper,
      "hasTelework":info.hasTelework,
      "supervisorId": info.supervisorid
    };
    return this.http.post(environment.apiUrl + '/UpdateUserProfile', body, { 'headers': authHeader, responseType: "text" });
  }

  //Method use to update user direct reports
  public updateDirectReports(supervisorId: number, userIDs: Array<number>, command: string): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    const body = {
      "SupUserID": supervisorId,
      "IUCommand": command,
      "UserInfoIDs": userIDs,
    };
    return this.http.post(environment.apiUrl + '/UpdateDirectReports', body, { 'headers': authHeader, responseType: "text" });
  }

  //Method use to update Telework Role
  public updateTelework(supervisorId: number,teleworkUserList:Array<number>): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    const body = {
      "SupUserID" : supervisorId,
      "ListOfTeleworkUsers": teleworkUserList
    };
    return this.http.post(environment.apiUrl + '/UpdateTeleworks', body, { 'headers': authHeader, responseType: "text" });
  }

  //Old Method use to get user image from Badging office
  public getUserImageFromBadgingOffice(firstName: string, lastName: string): Observable<IUserPhotoResponse> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    let fName = 'FirstName=' + firstName;
    let lName = 'LastName=' + lastName;
    return this.http.get<IUserPhotoResponse>(environment.apiUrl + '/GetBadgeImage?' + fName + '&' + lName, { 'headers': authHeader });
  }


  //Old Method use to get user image from Badging office
  public getUserImageFromIDMSBadgingOffice(upid: number): Observable<IDMSUserPhotoResponse[]> {
    let fName = 'firstName=' + '%';
    let lName = 'lastName=' + '%';
    let personq = 'personId=' + upid;
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.get<IDMSUserPhotoResponse[]>(environment.apiUrl + '/GetUserInfo?' + fName + '&' + lName + '&' + personq, {headers:authHeader});
  }

  //Method use to add user in AVN Directory
  public addUserIntoAviationDirectory(newUser: INewUser): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.post(environment.apiUrl + '/AddAviationDirectory', newUser, { 'headers': authHeader, responseType: "text" });
  }

  //Method use to disable user in AVN directory
  public disableUser(userId: string): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.post(environment.apiUrl + '/DisableUser?userID=' + userId, null, { 'headers': authHeader, responseType: "text" });
  }
  //Method use to enable user in AVN directory
  public enableUser(userId: string): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    //console.log("userid : " + userId);
    //console.log("Authorization : " + this.token);
    //console.log("UserName : " + this.userName);

    return this.http.post(environment.apiUrl + '/EnableUser?userID=' + userId, null, { 'headers': authHeader, responseType: "text" });
  }

  //Method use to upload user photo in AVN directory
  //define model class
  public uploadbadgeimage(userpic: IUserPhoto): Observable<string> {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    
    const body = {
      "userinfoid": userpic.userinfoid,
      "pic": userpic.pic,
    };

    return this.http.post(environment.apiUrl + '/UploadBadgeImage', body, { 'headers': authHeader, responseType: "text" });
  }

  private log(message: string) {
    //console.log(message);
  }

  public saveViewedUsers(userName: string, userId: number): void {
    let vu: IGroup[] = this.tokenStorageService.getViewedUsers() ?? [];

    //See if the user is already in the list.  if so, skip
    if (vu.find(f => f.ID == userId)) {
      return;
    }

    //see if the list is full.  if so, remove the first one
    vu.length == 12 && vu.shift();

    // Add the new user to the end of the list.
    vu.push({ Name: userName, ID: userId });

    this.tokenStorageService.saveViewedUsers(vu);

  }

  //This function will remove the current user from the viewed User list.
  public cleanViewedUsers(userId: string): void {
    let vu: IGroup[] = this.tokenStorageService.getViewedUsers() ?? [];
    let newVu: IGroup[] = [];
    vu.forEach(f => {
      if (f.ID != Number(userId)) {
        newVu.push(f);
      }
    });
    this.tokenStorageService.saveViewedUsers(newVu);
  }

  public isAviationDirectoryUser(loginName: string) {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': loginName
    });
    return this.http.get<number>(environment.apiUrl + '/isAviationDirectoryUser?loginName=' + loginName, {headers:authHeader});
  }

  public GetUserRoles(userInfoID: number) {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken
    });
    return this.http.get<UserRoles>(environment.apiUrl + '/GetUserRoles?userInfoID=' + userInfoID, {headers:authHeader});
  }

  public GetDivisionsWithSections() {
    const authHeader = new HttpHeaders({
      'Authorization': this.token,
      'AuthenticationToken': environment.AuthenticationToken,
      'UserName': this.userName
    });
    return this.http.get<number[]>(environment.apiUrl + '/GetDivisionsWithSections', {headers:authHeader});
  }

}
